module.exports = __webpack_public_path__ + "img/38.c506b9dc.png";